import { Capacitor } from "@capacitor/core";
import { Browser } from "@capacitor/browser";

// The web/PWA gateway URL is intentionally unchanged.
// Native WebViews must start payment from our HTTPS website instead.
const WEBSITE_BRIDGE = "https://passenger.marankoo.ir/payment-gateway.html";
const GATEWAY_START = "https://www.zarinpal.com/pg/StartPay/";
const AUTHORITY_PATTERN = /^A[0-9A-Za-z]{20,80}$/;
export const PAYMENT_RETURN_HANDLED_KEY = "marankoo:payment-return-handled";

// Only the native Android app sends this optional UI return hint to our backend.
// Pricing, travel ID, and the ordinary web request remain unchanged.
export function paymentRequestBody(travelId) {
  return Capacitor.isNativePlatform() && Capacitor.getPlatform() === "android"
    ? { travel_id: travelId, client_platform: "android" }
    : { travel_id: travelId };
}

export async function openMarankooPayment(authority) {
  if (typeof authority !== "string" || !AUTHORITY_PATTERN.test(authority)) {
    throw new Error("شناسه پرداخت نامعتبر است");
  }

  if (Capacitor.isNativePlatform()) {
    // A new payment attempt must be allowed to consume the same fixed
    // success/failure deep-link again.
    try {
      sessionStorage.removeItem(PAYMENT_RETURN_HANDLED_KEY);
    } catch (_) {
      // Ignore storage restrictions; App.js still has an in-memory guard.
    }

    // Hash fragments are not sent in the HTTP request for payment-gateway.html.
    // Browser.open opens an Android Custom Tab instead of navigating the app WebView.
    await Browser.open({ url: `${WEBSITE_BRIDGE}#${encodeURIComponent(authority)}` });
    return;
  }

  window.location.assign(`${GATEWAY_START}${authority}`);
}
